import Image from "next/image";

import { LinkifyText } from "@/components";

interface SuccessProps {
  message?: string;
}

const Success = ({ message }: SuccessProps) => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-neutral-100">
      <div className="bg-grey-20 flex-1 flex flex-col justify-center items-center w-full lg:w-[920px] min-h-screen md:min-h-[60vh] md:max-h-[80vh] md:rounded-xl p-6 shadow-sm overflow-hidden">
        <div className="-mt-[10%] relative w-[200px] h-[200px] md:w-[320px] md:h-[320px]">
          <Image
            fill
            src="/success.gif"
            alt="payment successful"
            className="object-cover w-full h-full"
            sizes="(max-width: 768px) 200px, 320px"
          />
        </div>
        <h3 className="text-2xl font-bold mt-6 text-center">
          Payment Successful
        </h3>
        <LinkifyText className="text-center max-w-[80%] mx-auto  mt-4">
          {message ||
            "You will receive an email with the details of the course."}
        </LinkifyText>
      </div>
    </div>
  );
};

export default Success;
